import React from 'react';

export default function Option({ selected = false, className = '' }) {
  return (
    <div
      className={`md:w-10 md:h-10 w-4 h-4 rounded-full border-[3px] flex items-center justify-center transition-all outline-none ring-0 ${selected
        ? 'bg-boonsOrange border-boonsOrange ring-4 ring-boonsOrange-200'
        : 'border-[#9A9EA6] bg-white'
        } ${className}`}
    >
      {selected && (
        <div className="md:w-3 md:h-3 w-2 h-2 bg-boonsOrange rounded-full ring-4 ring-white ring-offset-3 ring-offset-boonsOrange"></div>
      )}
    </div>
  );
}
